module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isNews) ? _c('div', {
    staticClass: "rules-acceptation"
  }, [_c('div', {
    staticClass: "middle"
  }, [(_vm.$language.current === 'fr') ? _c('div', [_c('p', [_vm._v("Avant d'utiliser Météo-Parapente, vous devez accepter les règles d'utilisation")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "Voir le réglement"
    },
    on: {
      "click": _vm.openLinkFr
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "prefered",
    attrs: {
      "type": "button",
      "value": "J'ai lu et j'accepte"
    },
    on: {
      "click": _vm.close
    }
  })]) : _c('div', [_c('p', [_vm._v("You must accept the rules before using Meteo-Parapente")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "Read the rules"
    },
    on: {
      "click": _vm.openLinkEn
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "prefered",
    attrs: {
      "value": "I have read and I accept",
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  })])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c2e1808"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rules-acceptation.vue
// module id = 342
// module chunks = 1